module.exports = __webpack_public_path__ + "img/group-updated.cc87eed5.svg";